/*
* 	@desc 用于把 标题栏透明化，所以看起来像全屏
*	@param {}
*/
import wxBridge from '../jsbridge/jsbridge_base.js';
import '../jsbridge/jsbridge_login_queue.js';
import env from '../common/env.js';
import * as base from '../base/mbase';
wxBridge.editAddress = function(param, callback) {
    var data = param || {};
    if( env.isiOS ) { // iOS需要二次校验，屏蔽该细节，业务方不需要关注
        wxBridge.VerifyJsapiModule.callAfterLoaded(function(opts) {
            data = Object.assign({}, {
                "appId": "wx62d9035fd4fd2059",
                "verifyAppId": "wx62d9035fd4fd2059",
                "verifySignType": 'sha1',
                "verifyNonceStr": base.getValue(opts, "sign.noncestr"),
                "verifySignature": base.getValue(opts, "sign.signature"),
                "verifyTimestamp": base.getValue(opts, "sign.timestamp")
            }, data)
            wxBridge.invoke('editAddress', data, callback);
        })
    }else {
        wxBridge.invoke('editAddress', data, callback);
    }
};

export default wxBridge;

export const {
    editAddress
} = wxBridge;
